import { render, staticRenderFns } from "./ShareSubscribePanelMini.vue?vue&type=template&id=2a1fba55&scoped=true&"
import script from "./ShareSubscribePanelMini.vue?vue&type=script&lang=js&"
export * from "./ShareSubscribePanelMini.vue?vue&type=script&lang=js&"
import style0 from "./ShareSubscribePanelMini.vue?vue&type=style&index=0&id=2a1fba55&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1fba55",
  null
  
)

component.options.__file = "ShareSubscribePanelMini.vue"
export default component.exports